import { createAction } from '@ngrx/store';
import { DomainEntity } from '../../models';

export const domains = createAction(
    'DOMAINS',
    (payload: DomainEntity[]) => ({payload})
);
